import { SCALES } from "../constants/fontScales";
import { THEMES } from "../constants/themes";

import { createSlice } from "@reduxjs/toolkit";

type State = {
    fontScale: SCALES;
    theme: THEMES;
};

const initialState: State = {
    fontScale: SCALES.default,
    theme: THEMES.default,
};

const settingsSlice = createSlice({
    name: "settings",
    initialState,
    reducers: {
        resetSettings: () => initialState,
        setFontScale: (state, { payload }: { payload: SCALES }) => {
            state.fontScale = payload;
        },
        setTheme: (state, { payload }: { payload: THEMES }) => {
            state.theme = payload;
        },
    },
});

export const { resetSettings, setFontScale, setTheme } = settingsSlice.actions;

export default settingsSlice.reducer;
